export default __webpack_public_path__ + "static/media/Logo_NIKE.6307d151.svg";